export default __webpack_public_path__ + "static/media/prestashop.7d43594e.svg";